import { Box, Grid } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import EditVenorBusiness from './EditVenorBusiness';
import ArchivedBusinessInfomation from './ArchivedBusinessInfomation';
import EditVendorpayments from './EditVendorpayments';
import Editvendorpreqal from './Editvendorpreqal';


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function EditVendor() {
  const params = new URLSearchParams(window.location.search);
  const Vendor = params.get("vendorid");
  const orgId = params.get("vendorid");

  const [value, setValue] = React.useState(0);
  const [answeer, setanswer] = React.useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const answer = (event) => {
    setanswer(event)
  }
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2} md={1}>

        </Grid>
        <Grid item xs={12} md={10}>
          <Box >
            <h4 className='' style={{ color: 'rgb(0,0,0)', marginLeft: "28px", fontSize: "28px", fontWeight: "600" }} >Edit Vendor</h4>
            <Box >
              <Box sx={{ borderColor: 'divider' }}>
                <Tabs sx={{ marginLeft: 3 }} value={value} onChange={handleChange} aria-label="basic tabs example">
                  <Tab label="Business Information" {...a11yProps(0)} />
                  <Tab label="Archived Business Information" {...a11yProps(1)} />
                  <Tab label="Payments" {...a11yProps(2)} />
                  <Tab label="Prequalification " {...a11yProps(3)} />

                </Tabs>
              </Box>
              <TabPanel value={value} index={0}>
                <EditVenorBusiness Vendorid={Vendor} org={orgId}  ansr={answer} />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <ArchivedBusinessInfomation value={answeer} />
              </TabPanel>
              <TabPanel value={value} index={2}>
                <EditVendorpayments  Vendorid={Vendor} org={orgId} />
              </TabPanel>
              <TabPanel value={value} index={3}>

                <Editvendorpreqal Vendorid={Vendor} org={orgId} />
              </TabPanel>

            </Box>

          </Box>
        </Grid>
        <Grid item xs={2} md={1}>

        </Grid>
      </Grid>

    </>
  )
}
